/* eslint-disable no-useless-escape */
import { DefaultOptionType } from "antd/es/select";

export const patternRFC =
  /^([A-ZÑ]|\&){3,4}[0-9]{2}(0[1-9]|1[0-2])([12][0-9]|0[1-9]|3[01])[A-Z0-9]{3}$/;
export const patternRfcPersonaFisica =
  /^([A-ZÑ]|\&){4}[0-9]{2}(0[1-9]|1[0-2])([12][0-9]|0[1-9]|3[01])[A-Z0-9]{3}$/;
export const patternRfcPersonaMoral =
  /^([A-ZÑ]|\&){3}[0-9]{2}(0[1-9]|1[0-2])([12][0-9]|0[1-9]|3[01])[A-Z0-9]{3}$/;
export const patternEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const uuidPattern =
  /^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$/;

export const patternPermiso =
  /^(H\/[0-9]{1,5}\/COM\/[0-9]{4})|(PL\/[0-9]{1,5}\/EXP\/ES\/[0-9]{4})|(PL\/[0-9]{1,5}\/EXP\/ES\/MM\/[0-9]{4})|(PL\/[0-9]{1,5}\/EXP\/ESA\/[0-9]{4})|(H\/[0-9]{1,5}\/COM\/[0-9]{4})|(PL\/[0-9]{1,5}\/EXP\/AE\/[0-9]{4})|(G\/[0-9]{1,5}\/COM\/GN\/[0-9]{4})|(G\/[0-9]{1,5}\/COM\/PETRO\/[0-9]{4})|(G\/[0-9]{1,5}\/COM\/CEE\/[0-9]{4})|(G\/[0-9]{1,5}\/EXP\/ES\/FE\/[0-9]{4})|(G\/[0-9]{1,5}\/EXP\/ES\/MM\/[0-9]{4})|(G\/[0-9]{1,5}\/LICUE\/[0-9]{4})|(G\/[0-9]{1,5}\/REG\/[0-9]{4})|(LP\/[0-9]{1,5}\/EXP\/ES\/[0-9]{4})|(LP\/[0-9]{1,5}\/EXP\/AUT\/[0-9]{4})|(LP\/[0-9]{1,5}\/COM\/[0-9]{4})|(PL\/[0-9]{1,5}\/EXP\/ESA\/MM\/[0-9]{4})|(SENER-REF-[0-9]{1,3}-[0-9]{4})|(SENER-TP-[0-9]{1,3}-[0-9]{4})|(SENER-CPG-[0-9]{1,3}-[0-9]{4})$/;

export const patternpermisoTransporteCRE =
  /^(PL\/[0-9]{1,5}\/TRA\/OM\/[0-9]{4})|(PL\/[0-9]{1,5}\/TRA\/DUC\/[0-9]{4})|(PL\/[0-9]{1,5}\/TRA\/TM\/[0-9]{4})|(PQ\/[0-9]{1,5}\/TRA\/DUC\/[0-9]{4})|(G\/[0-9]{1,5}\/TUP\/[0-9]{4})|(G\/[0-9]{1,5}\/SAB\/[0-9]{4})|(G\/[0-9]{1,5}\/TRA\/OM\/[0-9]{4})|(P\/[0-9]{1,5}\/TRA\/TM\/[0-9]{4})|(P\/[0-9]{1,5}\/TRA\/OM\/[0-9]{4})|(G\/[0-9]{1,5}\/TRA\/[0-9]{4})|(GN\/[0-9]{1,5}\/P\/TRA\/DUC\/[0-9]{4})|(GN\/[0-9]{1,5}\/TRA\/DUC\/[0-9]{4})|(P\/[0-9]{1,5}\/TRA\/DUC\/[0-9]{4})|(P\/[0-9]{1,5}\/P\/TRA\/DUC\/[0-9]{4})|(LP\/[0-9]{1,5}\/TRA\/DUC\/[0-9]{4})|(G\/[0-9]{1,5}\/LPT\/[0-9]{4})|(LP\/[0-9]{1,5}\/TRA\/[0-9]{4})$/;

export const patternPermisoAlmacenamiento =
  /^(PL\/[0-9]{1,5}\/ALM\/[0-9]{4})|(PQ\/[0-9]{1,5}\/ALM\/[0-9]{4})|(PL\/[0-9]{1,5}\/ALM\/AE\/[0-9]{4})|(G\/[0-9]{1,5}\/ALM\/[0-9]{4})|(P\/[0-9]{1,5}\/ALM\/[0-9]{4})|(LP\/[0-9]{1,5}\/ALM\/[0-9]{4})|(G\/[0-9]{1,5}\/LPA\/[0-9]{4})$/;

export const internationalImportExportPermission =
  /^[a-zA-Z0-9]{4}C[a-zA-Z0-9]{9}$/;

export const importExportPlace =
  /^(0[1-2]|0[5-8]|1[1-2]|14|1[6-9]|20|2[2-8]|3[0-1]|3[3-4]|3[7-9]|40|4[2-4]|4[6-8]|5[0-3]|6[4-5]|67|73|75|8[0-4])([0-7])?$/;

export const internationalCustomDeclaration =
  /^[0-9]{2} (0[1-2]|0[5-8]|1[1-2]|14|1[6-9]|20|2[2-8]|3[0-1]|3[3-4]|3[7-9]|40|4[2-4]|4[6-8]|5[0-3]|6[4-5]|67|73|75|8[0-4]) [0-9]{4} [0-9](?!0{6})[0-9]{6}$/;

export const isValidRfc = (rfcInput = "") => patternRFC.test(rfcInput);

export const isValidRfcPersonaFisica = (rfcInput = "") =>
  patternRfcPersonaFisica.test(rfcInput);

export const isValidRfcPersonaMoral = (rfcInput = "") =>
  patternRfcPersonaMoral.test(rfcInput);

export const isValidEmail = (emailInput = "") => patternEmail.test(emailInput);

export const validateCantidadMonetaria = (_: unknown, value: number) => {
  if (value > 1000000000000)
    return Promise.reject("El precio no puede sobrepasar $1000000000000 MXN.");
  if (value < 0) return Promise.reject("El precio no puede ser negativo.");
  return Promise.resolve();
};

export const validateValorNumerico = (_: unknown, value: number) => {
  if (value > 100000000000)
    return Promise.reject(
      "El volumen no puede sobrepasar 100000000000 Litros."
    );
  if (value < 0) return Promise.reject("El volumen no puede ser negativo.");
  return Promise.resolve();
};

export const filterCombo = (input: string, option?: DefaultOptionType) =>
  option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
